<script setup>
    defineProps({fill: String});
</script>
<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6.75C7.86405 6.75 9.375 5.23891 9.375 3.375C9.375 1.51109 7.86405 0 6 0C4.13618 0 2.625 1.51109 2.625 3.375C2.625 5.23891 4.13618 6.75 6 6.75ZM8.24995 7.5H3.75005C1.67904 7.5 0 9.1789 0 11.25C0 11.6642 0.335859 12 0.749953 12H11.25C11.6641 12 12 11.6642 12 11.25C12 9.1789 10.3211 7.5 8.24995 7.5Z"
      :fill="fill ? fill : '#98A2B3'"
    />
  </svg>
</template>
